import { Component, OnInit } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { RouterModule, Router } from '@angular/router';
import { MaintenanceTypeService } from '../../core/services/maintenance-type.service';
import { ViewTypeService } from '../../core/services/view-type.service';
import { HttpClientModule, HttpErrorResponse } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { ViewType } from '../../core/models/view-type.model';
import { MaintenanceTypeFormBaseComponent } from '../maintenance-type-form-base.component';

@Component({
  selector: 'app-maintenance-type-create',
  templateUrl: './maintenance-type-create.component.html',
  styleUrls: ['./maintenance-type-create.component.scss'],
  standalone: true,
  imports: [ReactiveFormsModule, RouterModule, HttpClientModule, CommonModule],
})
export class MaintenanceTypeCreateComponent
  extends MaintenanceTypeFormBaseComponent
  implements OnInit
{
  override viewTypes: ViewType[] = [];

  constructor(
    protected override fb: FormBuilder,
    private maintenanceTypeService: MaintenanceTypeService,
    private viewTypeService: ViewTypeService,
    private router: Router,
  ) {
    super(fb);
  }

  ngOnInit(): void {
    this.loadViewTypes();
  }

  loadViewTypes(): void {
    this.viewTypeService.getViewTypes().subscribe({
      next: viewTypes => {
        this.viewTypes = viewTypes;
      },
      error: (error: HttpErrorResponse) => {
        console.error('Error al cargar los tipos de vista:', error.message);
        this.errorMessage = error.error.message || 'Ocurrió un error al cargar los tipos de vista';
      },
    });
  }

  onSubmit(): void {
    if (this.maintenanceTypeForm.valid) {
      this.maintenanceTypeService.createMaintenanceType(this.maintenanceTypeForm.value).subscribe({
        next: response => {
          console.log('Tipo de Mantenimiento creado:', response);
          this.router.navigate(['/maintenance-types']);
        },
        error: (error: HttpErrorResponse) => {
          console.error('Error al crear el tipo de mantenimiento:', error.message);
          this.errorMessage =
            error.error.message || 'Ocurrió un error al crear el tipo de mantenimiento';
        },
        complete: () => {
          console.log('Solicitud de creación de tipo de mantenimiento completada');
        },
      });
    } else {
      this.markAllFieldsAsTouched();
    }
  }
}
